<template>
    <div class="home">
        <div class="box">	
              
            
            <form @submit.prevent="saveSampleRequest">
                <div class="notification is-info">
                    <p>Please use this screen to create a new sample request and supply generic information. You will add specific garment information on the next screen.</p>
                </div>
                <div class="field">
                          <label class="label">Requestor</label>
                          <div class="control select is-fullwidth">
                              <select class="input" v-model="user_id"  required >
                                <option value="">Please select ...</option>
                               <option :value="row.userID" v-for="row in users" :key="row.userID">{{ row.firstname}} {{  row.surname }}</option>
                               
                            </select>
                          </div>
                      </div>

                      <div class="field">
                          <label class="label">Team/Club Name </label>
                          <div class="control">
                            <select class="input" v-model="team_id"  required >
                                <option value="">Please select ...</option>
                                <option value="-1">New Team or not available in list below</option>
                                <option :value="row.id" v-for="row in teams" :key="row.id">{{ row.name}}</option>
                               
                            </select>
                             
                          </div>
                      </div>

                      <div class="field" v-if="team_id == -1">
                          <label class="label">Other Team/Club Name </label>
                          <div class="control">
                              <input class="input" type="text" v-model="club_name" placeholder="" />
                             
                          </div>
                      </div>

                      <div class="field ">
                          <label class="label">Sample Type</label>
                          <div class="control select is-fullwidth">
                              <select class="input" v-model="sample_type_id"  required >
                                <option value="">Please select ...</option>
                                <option :value="row.id" v-for="row in sample_types" :key="row.id">{{ row.name}}</option>
                               
                            </select>
                          </div>
                      </div>
      
                      <div class="field">
                          <label class="label">Is This A Follow Up To A Previous Request ? </label>
                          <div class="control">
                              <input class="input" type="text" v-model="follow_up" placeholder="Enter previous request ID here"  >
                             
                          </div>
                      </div>
                     
                      <div class="field">
                          <label class="label">Potential Order Quantity </label>
                          <div class="control">
                              <input class="input" type="number" v-model="quantity" min="1" step="1"  @keypress="isNumber($event)">
                             
                          </div>
                      </div>

                      <div class="field">
                          <label class="label">Generic Request Instructions</label>
                          <div class="control">
                              <textarea class="textarea"  v-model="instructions"  ></textarea>
                                <small>You can add instructions for each item on the next screen</small>
                          </div>
                      </div>

                      <div class="field" style="display:none">
                          <label class="label">Generic Attachments (applicable for all items)</label>
                          <div class="control">
                              <p><em>Derry 2024 Crest Logo.jpg</em></p>
                              <p><em>Embroidery Photo Logo.png</em></p>
                                <input type="file" />
                          </div>
                      </div>

                      
      
                      <div class="field is-grouped mt-5">
                          <div class="control">
                              <button class="button is-success" :disabled="working===true">Create Request (and proceed to add items)</button>
                          </div>
                      </div>
                  </form>
            
          </div>
          
      </div>
  </template>

<script>
    import SampleService from '@/services/SampleService.js';
    import UtilityService from '@/services/UtilityService.js';

    
    
    export default {
        
      name: 'NewSampleRequest',
        mixins: [],
        data: function () {
            return {
                   loading : false,
                  search: "",
                    API_NAME: process.env.VUE_APP_API_NAME,
                    accessToken: '',
                    users: [],
                    sample_types: [],
                    
                    quantity: '',
                   date: this.getStartDate(),
                    working:false,
                    instructions: '',
                    user_id: '',
                    sample_type_id: '',
                    follow_up: '',
                    teams:[],
                    team_id: '',
                    club_name: '',
                    
                    
                   
            }
        },
        created() {
          this.getAccessToken()
            .then(() => { 
               this.getUserMappings();
               this.getSampleTypes();
               this.getTeams();
            });
          
        },
        methods: {
            async getUserMappings() {
                UtilityService.getSimpleApiData(this.accessToken, "user_mappings").then(
                response => this.users = response 
                );
            },
            async getTeams() {
                UtilityService.getSimpleApiData(this.accessToken, "teams").then(
                response => this.teams = response 
                );
            },
            async getSampleTypes() {
                UtilityService.getSimpleApiData(this.accessToken, "sample_types").then(
                response => this.sample_types = response 
                );
            },
            
            async saveSampleRequest() {
                
                this.working = true
                var formdata = { 
                    user_id: this.user_id,
                    team_id: this.team_id,
                    club_name: this.club_name,
                    follow_up: this.follow_up,
                    sample_type_id: this.sample_type_id,
                    quantity : this.quantity,
                    instructions : this.instructions
                }; 

                SampleService.saveSampleRequest(this.accessToken, formdata)
                .then((response) => {
                    this.$router.push("/samples/view/" + response.id);
                    console.log(response)
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                        this.working = false
                });
                
            },
            getStartDate() {
            
                var d = new Date();
                
                d.setDate(d.getDate() );
                return d.toISOString().slice(0,10);
                
            },
           
        }
    }
    </script>